import { clearLogoutStorage } from 'Services/logoutStorage';
import { useAuth0 } from 'auth0/reactAuth0Spa';
import Loading from 'Body/Statuses/Loading';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const AdminLogout = () => {
  const { logout, isAuthneticated } = useAuth0();
  const history = useHistory();

  useEffect(() => {
    // sessionStorage.removeItem('department');
    // sessionStorage.removeItem('roleChoice');
    clearAccountContext();

    setTimeout(() => {
      try {
        logout();
      } catch (error) {
        history.push('/');
      } finally {
      }
      //   if (isAuthneticated) {
      //     logout();
      //   } else {
      //     console.log('No auth');
      //     history.push('/');
      //   }
      //   if (auth0 && auth0.logout) {
      //     auth0.logout();
      //   } else {
      //     console.log('No auth');
      //     history.push('/');
      //   }
    }, 3000);
  }, []);

  const clearAccountContext = () => {
    clearLogoutStorage({
      local: { clear: () => window.localStorage.clear() },
      session: {
        removeItem: key => window.sessionStorage.removeItem(key),
        key: index => window.sessionStorage.key(index),
        get length() { return window.sessionStorage.length; },
      },
    });

  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '85vh',
          }}
        >
          <Loading options={{ labelText: 'Logging you out. . .' }} />
        </div>
      </div>
    </div>
  );
};

export default AdminLogout;
